module.exports = __webpack_public_path__ + "static/media/help_icon.536bda0a.svg";